import { Pipe, PipeTransform } from '@angular/core';

import { GlobalFilterKeys } from '@models/module/fields/enums';
import { EntityTableRow } from '@shared/components/data-list/common/services/table-data.service';

enum ColorCodeEnum {
  green = '#28b293',
  red = '#bf5350',
  yellow = '#ffee8c',
}

@Pipe({
  name: 'getColorCode',
})
export class ColorCodePipe implements PipeTransform {
  transform({ overdue, near_overdue }: EntityTableRow): ColorCodeEnum {
    // TODO: that shouldn't be happening here
    const isOverdue = this.getBooleanValue(overdue);
    const isNearOverdue = this.getBooleanValue(near_overdue);
    const isDueSoon = !isOverdue && isNearOverdue;
    return isDueSoon ? ColorCodeEnum.yellow : isOverdue ? ColorCodeEnum.red : null;
  }

  private getBooleanValue(value: string | boolean): boolean {
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }
    return value;
  }
}

@Pipe({
  name: 'getFilterColorCode',
})
export class FilterColorCode implements PipeTransform {
  transform(key: GlobalFilterKeys | string): ColorCodeEnum {
    const isOverdue = key === GlobalFilterKeys.Overdue;
    const isDueSoon = key === GlobalFilterKeys.DueSoon;
    return isDueSoon ? ColorCodeEnum.yellow : isOverdue ? ColorCodeEnum.red : null;
  }
}
